import { motion } from 'motion/react';
import { useNavigate } from 'react-router-dom';
import { LabsHeaderContainer } from './labs-header-container';
import type { FilterableClassification } from '../biomarker-filter/biomarker-filter';

interface LabsHeaderAllBiomarkersProps {
  className?: string;
  selectedFilter?: FilterableClassification | null;
}

const filterTitleMap: Record<FilterableClassification, string> = {
  optimal: 'Optimal Biomarkers',
  normal: 'Normal Biomarkers',
  out_of_range: 'Out of Range Biomarkers',
  critical: 'Critical Biomarkers',
};

export function LabsHeaderAllBiomarkers({ className, selectedFilter }: LabsHeaderAllBiomarkersProps) {
  const navigate = useNavigate();

  // Determine title based on selected filter
  const title = selectedFilter ? filterTitleMap[selectedFilter] : 'All Biomarkers';

  return (
    <LabsHeaderContainer minHeight="md:min-h-[300px]" className={className}>
      {/* Back button */}
      <button
        onClick={() => navigate(-1)}
        className="mb-4 flex items-center gap-2 text-sm font-medium uppercase tracking-wider text-white transition-opacity hover:opacity-80"
        type="button"
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M15 18L9 12L15 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        Back
      </button>

      {/* Title */}
      <motion.h1
        className="text-2xl font-bold leading-tight text-white md:text-[44px] md:font-normal md:leading-[56px] md:tracking-[0.3px]"
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        key={title} // Re-animate when title changes
      >
        {title}
      </motion.h1>
    </LabsHeaderContainer>
  );
}
